module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAdklEQVR4nGNgGPLg/xFh3v+H5QRJwkeEefEa+uew5Oo/RyT/k4lX4XTpH/INBWOsLv9/WE6QYoMPywmOGvx/YIPi92HJX38OSUb+Pizlgg9D1Ej+GniD/4wmtz9DKyiO0KgQAgFQ0Ueuob+PSK5koHtBzzAUAAAtHjSkvsJq+gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icons8-negative-22.png
// module id = b0sV
// module chunks = 0